import CaseDownloadCTA from './CaseDownloadCTA'

export default CaseDownloadCTA
export type { CaseDownloadCTAProps, CaseDownloadCTAItem } from './CaseDownloadCTA'
